import axios from 'axios';
import { removeTokens } from '../utils/auth.utils';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
    'api-key': process.env.REACT_APP_API_KEY || '123-456-789-000',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('@bc-t');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Sesión expirada.');
      removeTokens();
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export default api;
